import React, { useState } from 'react';
import SpeciesManagement from '../components/species-management';
import BreedsManagement from '../components/breeds-management';
import SizesManagement from '../components/sizes-management';

export default function AnimalSpeciesPage() {
  const [activeTab, setActiveTab] = useState('species');

  const tabs = [
    { id: 'species', label: 'Espécies'},
    { id: 'breeds', label: 'Raças'},
    { id: 'sizes', label: 'Tamanhos'},
  ];

  return (
    <div style={{ padding: '32px 48px' }}>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: 'var(--card-foreground)', marginBottom: 8, letterSpacing: '-0.5px' }}>
          Gerenciamento de Espécies
        </h1>
        <p style={{ color: 'var(--muted-foreground)', fontSize: 16 }}>
          Gerencie espécies, raças e tamanhos de animais do sistema
        </p>
      </div>

      {/* Tabs */}
      <div style={{
        display: 'flex',
        gap: 12,
        marginBottom: 32,
        borderBottom: '2px solid var(--border)',
        paddingBottom: 0
      }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              background: activeTab === tab.id ? 'var(--card)' : 'transparent',
              border: 'none',
              borderBottom: activeTab === tab.id ? '3px solid var(--primary)' : '3px solid transparent',
              padding: '14px 24px',
              fontSize: 15,
              fontWeight: 600,
              color: activeTab === tab.id ? 'var(--primary)' : 'var(--muted-foreground)',
              cursor: 'pointer',
              transition: 'all 0.2s',
              borderRadius: '8px 8px 0 0',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
            onMouseEnter={(e) => {
              if (activeTab !== tab.id) {
                e.currentTarget.style.background = 'var(--muted)';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== tab.id) {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <span style={{ fontSize: 18 }}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div>
        {activeTab === 'species' && <SpeciesManagement />}
        {activeTab === 'breeds' && <BreedsManagement />}
        {activeTab === 'sizes' && <SizesManagement />}
      </div>
    </div>
  );
}
